import React, { useContext } from 'react'
import { CloseDiv, Container, ButtonDiv, Header, InfosContainer, RowDatas, ButtonContainer } from './style'
import close from '../../../assets/close-icon.svg'
import pencil from '../../../assets/productions/pencil.svg'
import ModalContext from '../../../contexts/ModalContext'
import { ServicesContext } from '../../../contexts/ServicesContext'
import { fieldsAndValues } from '../CreateServiceModal/utils'

const CheckServiceOrderModal:React.FC = () => {
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { service } = useContext(ServicesContext)

  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
  
    return `${day}/${month}/${year}`
  }
  
  return(
    <Container>
      <Header>
        <h2>Ordem de serviço: {service?.id}</h2>
        <CloseDiv onClick={() => (setModalActive(false))}>
          <img src={close} />
        </CloseDiv>
      </Header>
      <InfosContainer>
        {fieldsAndValues.map((item, index) => (
          <RowDatas key={index}>
            
          </RowDatas>
        ))}
      </InfosContainer>
      <ButtonContainer>
        <ButtonDiv>
          <img src={pencil} />
          Editar ordem
        </ButtonDiv>
      </ButtonContainer>
    </Container>
  )
}

export default CheckServiceOrderModal